// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3WEdV","notes":"Notes_notes__20IQ6","note":"Notes_note__BCxEi","markdown":"Notes_markdown__DEohT"};